import type { ChipDefinition } from './types'

export const chipDefinitions: ChipDefinition[] = [
  {
    id: 'doubleUp',
    name: 'Double Up',
    description:
      'Doubles all the points you earn this gameweek. Play it on a week you feel confident about.',
    implemented: true,
  },
  {
    id: 'goalfest',
    name: 'Goalfest',
    description:
      'Score +1 point for every goal in a fixture you correctly call the outcome for — exact scores count too.',
    implemented: true,
  },
  {
    id: 'cleanSweep',
    name: 'Clean Sweep',
    description:
      "Correctly call every fixture's outcome and score big — 10 points per game, 20 for exact scores. Miss even one and the whole gameweek scores zero.",
    implemented: true,
  },
]
